import React from "react";

const DefenceExpertise = () => {
  const cards = [
  {
  title: "MR-SAM Systems",
  desc: "Medium-range surface-to-air missile integration and electronics",
  icon: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0007 25.6667C20.444 25.6667 25.6673 20.4434 25.6673 14C25.6673 7.55672 20.444 2.33337 14.0007 2.33337C7.55733 2.33337 2.33398 7.55672 2.33398 14C2.33398 20.4434 7.55733 25.6667 14.0007 25.6667Z"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6667 14H21"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00065 14H2.33398"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 7.00004V2.33337"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 25.6667V21"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

  {
  title: "Combat Management Systems (CMS)",
  desc: "Naval CMS electronics design, repair, and upgrades",

icon:<i class="bi bi-shield"></i>
},

    {
  title: "Electronic Warfare Systems",
  desc: "EW suite electronics and signal processing",
  icon: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.71719 22.2833C1.16719 17.7333 1.16719 10.2667 5.71719 5.71667"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.10039 18.9001C6.41706 16.2167 6.41706 11.7834 9.10039 8.9834"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9993 16.3333C15.288 16.3333 16.3327 15.2886 16.3327 14C16.3327 12.7113 15.288 11.6666 13.9993 11.6666C12.7107 11.6666 11.666 12.7113 11.666 14C11.666 15.2886 12.7107 16.3333 13.9993 16.3333Z"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9004 9.09998C21.5837 11.7833 21.5837 16.2166 18.9004 19.0166"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2832 5.71667C26.8332 10.2667 26.8332 17.6167 22.2832 22.1667"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

   {
  title: "Weapon Control Electronics",
  desc: "Fire control computers and weapon system interfaces",
  icon: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8327 24.5C19.276 24.5 24.4994 19.2766 24.4994 12.8333C24.4994 6.38997 19.276 1.16663 12.8327 1.16663C6.38936 1.16663 1.16602 6.38997 1.16602 12.8333C1.16602 19.2766 6.38936 24.5 12.8327 24.5Z"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

   {
  title: "Radar & Surveillance Systems",
  desc: "Radar display processors and surveillance electronics",
  icon: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2476 5.7516C20.431 3.93302 18.0646 2.7653 15.5161 2.42986C12.9676 2.09442 10.3796 2.61003 8.1543 3.8966"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66602 7H4.67768"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.6724 11.2234C2.23501 13.0049 2.22391 14.8645 2.64 16.6512C3.05609 18.4379 3.88764 20.1012 5.06714 21.5063C6.24664 22.9113 7.74085 24.0184 9.42845 24.7376C11.1161 25.4568 12.9495 25.768 14.7799 25.6458C16.6103 25.5235 18.3861 24.9714 19.9631 24.0342C21.5401 23.097 22.8738 21.8011 23.856 20.2517C24.8383 18.7023 25.4413 16.9432 25.6162 15.1171C25.791 13.2909 25.5328 11.4493 24.8624 9.7417"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9465 9.0534C18.2751 8.37809 17.473 7.84688 16.5892 7.49225C15.7054 7.13763 14.7586 6.96706 13.8066 6.99098C12.8546 7.0149 11.9175 7.2328 11.0527 7.63136C10.1878 8.02992 9.41339 8.60075 8.77675 9.30892C8.14011 10.0171 7.65465 10.8477 7.35009 11.75C7.04553 12.6522 6.92826 13.6071 7.00547 14.5563C7.08267 15.5054 7.35272 16.4288 7.7991 17.27C8.24547 18.1112 8.85879 18.8524 9.60151 19.4484"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 21H14.0117"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9884 13.6033C21.0519 14.7132 20.8501 15.8223 20.3997 16.8387C19.9493 17.8551 19.2633 18.7497 18.3984 19.4483"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9993 16.3334C15.288 16.3334 16.3327 15.2887 16.3327 14.0001C16.3327 12.7114 15.288 11.6667 13.9993 11.6667C12.7107 11.6667 11.666 12.7114 11.666 14.0001C11.666 15.2887 12.7107 16.3334 13.9993 16.3334Z"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6445 12.355L22.2479 5.75171"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
},

  {
  title: "MIL-Grade Rugged Electronics",
  desc: "Environmental hardened systems for extreme conditions",
  icon: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.666 11.6667V5.83341C11.666 5.524 11.7889 5.22725 12.0077 5.00846C12.2265 4.78966 12.5233 4.66675 12.8327 4.66675H15.166C15.4754 4.66675 15.7722 4.78966 15.991 5.00846C16.2098 5.22725 16.3327 5.524 16.3327 5.83341V11.6667"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.334 7C18.1905 7 19.971 7.7375 21.2837 9.05025C22.5965 10.363 23.334 12.1435 23.334 14V17.5"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66602 17.5V14C4.66602 12.1435 5.40351 10.363 6.71627 9.05025C8.02902 7.7375 9.8095 7 11.666 7"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5007 17.5H3.50065C2.85632 17.5 2.33398 18.0223 2.33398 18.6667V21C2.33398 21.6443 2.85632 22.1667 3.50065 22.1667H24.5007C25.145 22.1667 25.6673 21.6443 25.6673 21V18.6667C25.6673 18.0223 25.145 17.5 24.5007 17.5Z"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}

  ];

  return (
    <div
      style={{
        fontFamily: "Inter, sans-serif",
        padding: "80px 20px",
        backgroundColor: "#fff",
      }}
    >
      {/* Main Heading */}
      <h1
        style={{
          textAlign: "center",
          fontSize: "36px",
          fontWeight: 700,
          marginBottom: "10px",
          color: "#111",
           marginTop: "60px",

        }}
      >
        Defence Expertise & Integration
      </h1>

      <p
        style={{
          textAlign: "center",
          fontSize: "15px",
          color: "#6b7280",
          marginBottom: "60px",
        }}
      >
        Comprehensive electronics expertise for mission-critical defence systems
      </p>

      {/* Section Title */}
      <h2
        style={{
          textAlign: "center",
          fontSize: "22px",
          fontWeight: 600,
          marginBottom: "6px",
          color: "#0f172a",
        }}
      >
        System Expertise
      </h2>

      <p
        style={{
          textAlign: "center",
          fontSize: "14px",
          color: "#64748b",
          marginBottom: "50px",
        }}
      >
        Deep domain knowledge across weapon systems and combat platforms
      </p>

      {/* Cards Wrapper */}
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr", // 👈 STRICT 2 COLUMNS
          gap: "28px",
        }}
      >
        {cards.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              gap: "16px",
              padding: "22px 24px",
              borderRadius: "12px",
              backgroundColor: "#fff",
              border: "1px solid #eef2f7",
              boxShadow: "0 6px 24px rgba(15, 23, 42, 0.06)",
            }}
          >
            {/* Icon */}
            <div
              style={{
                width: "44px",
                height: "44px",
                borderRadius: "10px",
                backgroundColor: "#ff8a00",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "18px",
                flexShrink: 0,
              }}
            >
              {item.icon}
            </div>

            {/* Content */}
            <div>
              <h3
                style={{
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#0f172a",
                  marginBottom: "6px",
                }}
              >
                {item.title}
              </h3>

              <p
                style={{
                  fontSize: "13px",
                  lineHeight: "1.6",
                  color: "#64748b",
                }}
              >
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile Fix */}
      <style>
        {`
          @media (max-width: 768px) {
            div[style*="grid-template-columns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default DefenceExpertise;
